import Repository from './Repository';
import {empty} from "../../shared/utils";

const resource = 'person';

export default {
    get() {
        return Repository.get('people')
    },
    getPerson(personId) {
        return Repository.get(resource + '/' + personId +'?details[]=personFullDetails')
    },
    createPerson(payload) {
        return Repository.post(resource, payload)
    },
    updatePerson(personId, payload) {
        return Repository.put(resource + '/' + personId, payload)
    },
    searchPeople(search) {
      let query = '?'

      if (!empty(search.name)) {
        query += '&names[]='+search.name
      }

      if (!empty(search.email)) {
        query += '&emails[]=' + search.email
      }

      if (!empty(search.limit)) {
        query += '&limit='+search.limit
      }

      if (!empty(search.page)) {
        query += '&page='+search.page
      }

      return Repository.get('people' + query);
    }
}
